type CountryList = Record<string, { name?: string }>;

const toCountryIds = (ids: Array<number | string> = []) => [
    ...new Set(ids.map(Number).filter(Number.isFinite)),
];

export const normalizeBroadcastCountries = (
    selectedCountryIds: Array<number | string> = [],
    countryList: CountryList = {},
    savedCountryNames: string[] = [],
) => {
    const selectedCountries = selectedCountryIds.reduce<
        Array<{ id: number; savedName?: string }>
    >((countries, rawId, index) => {
        const id = Number(rawId);
        if (
            !Number.isFinite(id) ||
            countries.some(country => country.id === id)
        ) {
            return countries;
        }

        countries.push({ id, savedName: savedCountryNames[index] });
        return countries;
    }, []);
    const selectedIds = selectedCountries.map(({ id }) => id);
    const availableIds = toCountryIds(Object.keys(countryList));
    const isUnrestricted =
        selectedIds.length === 0 ||
        (availableIds.length > 0 &&
            selectedIds.length === availableIds.length &&
            availableIds.every(id => selectedIds.includes(id)));

    if (isUnrestricted) {
        return {
            broadcastCountryIds: [],
            broadcastCountryNames: [],
        };
    }

    return {
        broadcastCountryIds: selectedIds,
        broadcastCountryNames: selectedCountries
            .map(
                ({ id, savedName }) =>
                    countryList[String(id)]?.name || savedName,
            )
            .filter((name): name is string => Boolean(name)),
    };
};
